// extracted by mini-css-extract-plugin
module.exports = {"boxWrapper":"TranslateOptionsBox_boxWrapper__1ShrY","button":"TranslateOptionsBox_button__21_Bz"};